import { Box, Button, Stack, TextField, Typography } from '@mui/material';

import { useT } from '../i18n/LanguageContext';

import { generatePassword } from './generatePassword';

/**
 * A password somebody sets for somebody else, so it is visible rather than masked: the person setting it
 * has to pass it on. It is stored only as a hash.
 */
export const PasswordField = ({ value, onChange }: { value: string; onChange: (next: string) => void }) => {
  const t = useT();

  return (
    <Box>
      <Stack direction="row" spacing={1} alignItems="flex-start">
        <TextField
          fullWidth
          required
          label={t('field.password')}
          value={value}
          onChange={(event) => onChange(event.target.value)}
          inputProps={{ style: { fontFamily: 'ui-monospace, monospace' } }}
        />
        <Button sx={{ mt: 0.5, flexShrink: 0 }} onClick={() => onChange(generatePassword())}>
          {t('password.generate')}
        </Button>
      </Stack>
      <Typography variant="caption" sx={{ color: 'text.secondary', display: 'block', mt: 1 }}>
        {t('password.hint')}
      </Typography>
    </Box>
  );
};
